import {useAppSelector} from "../../../redux/hooks";
import {dashboardStore} from "../store/dashboardPageStore";
import {IDashboardPagePlayingTimeSection, IDashboardPagePlayingTimeSummary} from "../store/IDashboardPageStore";

export interface IPlayingTimeLogic {
  bootcamp?: IDashboardPagePlayingTimeSection;
  courses?: IDashboardPagePlayingTimeSection;
  songs?: IDashboardPagePlayingTimeSection;
  summary?: IDashboardPagePlayingTimeSummary;
}

export const usePlayingTimeLogic = (): IPlayingTimeLogic => {
  const {bootcamp, courses, songs, summary} = useAppSelector(dashboardStore.getPlayingTimeSelectedRangeData);
  return {
    bootcamp,
    courses,
    songs,
    summary,
  };
}
